import { forwardRef } from 'react';

import {
    TableTriggerButton,
    type TableTriggerButtonProps,
} from '@/components/tiptap-editor/tiptap-node/table-node/ui/table-trigger-button/table-trigger-button';

export type GridLayoutTriggerButtonProps = Omit<TableTriggerButtonProps, 'mode'>;

export const GridLayoutTriggerButton = forwardRef<HTMLButtonElement, GridLayoutTriggerButtonProps>((props, ref) => (
    <TableTriggerButton
        ref={ref}
        mode="grid"
        {...props}
    />
));

GridLayoutTriggerButton.displayName = 'GridLayoutTriggerButton';

export default GridLayoutTriggerButton;
